import { setConfig } from '@/shared/config';

type QuickQuoteRuntimeConfig = {
	apiHost?: string;
	apiSecure?: string;
	googleMapsApiKey?: string;
};

const loadRuntimeConfig = async (): Promise<QuickQuoteRuntimeConfig> => {
	const response = await fetch('/quick-quote/config.json', {
		cache: 'no-store'
	});
	if (!response.ok) throw new Error('Could not load quick quote configuration');
	return await response.json();
};

export const loadQuickQuoteConfig = async (): Promise<void> => {
	const data = await loadRuntimeConfig();
	const apiSecure = data.apiSecure === 'true';
	const apiHost = data.apiHost || window.location.hostname;

	setConfig({
		isDev: process.env.NODE_ENV === 'development',
		apiSecure,
		apiHost,
		pusherKey: '',
		pusherCluster: '',
		cloverClientId: '',
		cloverServerUrl: '',
		googleAnalyticsId: '',
		googleMapsApiKey: data.googleMapsApiKey || '',
		googleMapsVersion: '3.43',
		getBaseURL: () => `http${apiSecure ? 's' : ''}://${apiHost}`,
		getBaseWsURL: () => `ws${apiSecure ? 's' : ''}://${apiHost}`
	});
};
